export enum ProductTypes {
  MEMBERSHIPS = 'memberships',
  BUNDLES = 'bundles',
  ORCHESTRAS = 'orchestras'
}